import { render, staticRenderFns } from "./SDVereine.vue?vue&type=template&id=233de628&scoped=true&"
import script from "./SDVereine.vue?vue&type=script&lang=js&"
export * from "./SDVereine.vue?vue&type=script&lang=js&"
import style0 from "./SDVereine.vue?vue&type=style&index=0&id=233de628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233de628",
  null
  
)

export default component.exports